import presenter from "./presenter";
import { isNonEmptyString, isValidEmail, isPhoneNum } from "helpers/validation";

const createUserPayload = (nameInputRef, emailInputRef, phoneInputRef, userPrivilege) => {
    var payload = {}
    const name = nameInputRef.current.value;
    if( name !== presenter.getFullName(userPrivilege) && isNonEmptyString(name) === true ) {
        payload.first_name = name.split(' ')[0];
        payload.last_name = name.split(' ')[1];
    }

    const email = emailInputRef.current.value; 
    if( email !== presenter.getEmail(userPrivilege) && isValidEmail(email) === true ) {
        payload.email = email;
    }

    const phone = phoneInputRef.current.value;
    if( phone !== presenter.getPhone(userPrivilege) && isPhoneNum(phone) === true ) {
        payload.phone_number = phone;
    }

    return payload;
}

const createUserPrivlegePayload = (accessLevelButtonRef, jobTitleInputRef, employeeIDInputRef, userPrivilege, accessLevelText, adminText, teamMemberText) => {
    var payload = {}
    const accessLevel = accessLevelButtonRef.current.innerText;
    if( accessLevel !== accessLevelText ) {
        if( accessLevel === adminText) {
            payload.is_admin = true;
        }else if ( accessLevel === teamMemberText) {
            payload.is_admin = false;
        }
    }

    const jobTitle = jobTitleInputRef.current.value;
    if( jobTitle !== presenter.getJobTitle(userPrivilege) && isNonEmptyString(jobTitle) === true ) {
        payload.position = jobTitle;
    }

    const employeeID = employeeIDInputRef.current.value;
    if( employeeID !== presenter.getEmployeeID(userPrivilege) && isNonEmptyString(employeeID) === true ) {
        payload.badge_id = employeeID;
    }

    return payload;
}

export default {
    createUserPayload,
    createUserPrivlegePayload,
}